import { render, staticRenderFns } from "./ReportOverview.vue?vue&type=template&id=2195afea&scoped=true"
import script from "./ReportOverview.vue?vue&type=script&lang=js"
export * from "./ReportOverview.vue?vue&type=script&lang=js"
import style0 from "./ReportOverview.vue?vue&type=style&index=0&id=2195afea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195afea",
  null
  
)

export default component.exports